<main
  class="jobs-home-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <ng-container *ngIf="contentReady; else homeJobsBootLoader">
    <section class="statistics-section jobs-home-section">
      <div class="atw-container">
        <div class="statistics-card-wrapper jobs-home-wrapper">
          <div class="statistics-header jobs-home-header">
            <div class="section-title statistics-title jobs-home-title">
              <span>
                <b>02</b>
              </span>

              <div>
                <h2>{{ 'atw.jobs.latestTitle' | transloco }}</h2>

                <p>{{ 'atw.jobs.latestSubtitle' | transloco }}</p>

                <p class="jobs-count-line">
                  {{
                    'atw.jobs.showingCount'
                      | transloco: {
                          visible: formatNumber(visibleJobs.length),
                          total: formatNumber(totalJobsCount)
                        }
                  }}
                </p>
              </div>
            </div>

            <div class="statistics-label jobs-home-label">
          
              {{ 'atw.statistics.liveLabel' | transloco }}
            </div>
          </div>

          <div class="jobs-loading home-state-card" *ngIf="isLoading">
            <span></span>
            <p>{{ 'atw.jobs.loading' | transloco }}</p>
          </div>

          <div
            class="home-error-card"
            *ngIf="errorMessage && !isLoading"
          >
            {{ errorMessage }}
          </div>

          <div
            class="empty-jobs home-state-card"
            *ngIf="!isLoading && !jobs.length"
          >
            <h3>{{ 'atw.jobs.emptyTitle' | transloco }}</h3>
            <p>{{ 'atw.jobs.emptyText' | transloco }}</p>
          </div>

          <div
            class="jobs-grid home-jobs-list"
            *ngIf="!isLoading && jobs.length"
          >
            <article
              class="jobs-card home-job-card"
              *ngFor="let job of visibleJobs; trackBy: trackByJobId"
            >
              <button
                type="button"
                class="card-share"
                (click)="openJobDetails(job)"
                aria-label="Open job"
              >
                ↗
              </button>

              <div class="job-card-head">
                              <img class="img-l" src="assets/as/9.webp" >

                <div>
                  <h3>{{ getJobTitle(job) }}</h3>

                  <p>{{ getCompanyName(job) }}</p>
                </div>
              </div>

              <div class="job-location-line">
                <span>
                     <img class="img-m" src="assets/as/21.webp" >
 {{ getCityName(job) }}, {{ getCountryName(job) }}
                </span>

                <span>•</span>

                <span>
                         <img class="img-m" src="assets/as/41.webp" > {{ getPostedAt(job) }}
                </span>
              </div>

              <strong class="job-salary">
                {{ getSalary(job) }}
              </strong>

              <div class="job-meta">
                <small>             <img class="img-m" src="assets/as/4.webp" > {{ getJobType(job) }}</small>
                <small> <img class="img-m" src="assets/as/1.webp" > {{ getWorkModel(job) }}</small>
                <small> <img class="img-m" src="assets/as/19.webp" > {{ formatNumber(job.views_count || 0) }}</small>
              </div>

              <div class="job-keywords" *ngIf="getTags(job, 3).length">
                <small *ngFor="let tag of getTags(job, 3)">
                  {{ tag }}
                </small>
              </div>

              <div class="job-card-actions">
                <button
                  type="button"
                  class="secondary-action"
                  (click)="openJobDetails(job)"
                >
                  {{ 'atw.jobs.viewDetails' | transloco }}

                </button>

                <button
                  *ngIf="!isCompanyUser()"
                  type="button"
                  class="primary-action"
                  (click)="applyForJob(job)"
                  [disabled]="isJobApplied(job)"
                >
                  {{ getApplyButtonLabel(job) }}
                </button>
              </div>
            </article>
          </div>

          <div class="jobs-footer" *ngIf="jobs.length">
            <button
              type="button"
              class="primary-action jobs-more-btn"
              (click)="goToJobsPage()"
            >
              {{ 'atw.jobs.showMore' | transloco }}
                
            </button>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-template #homeJobsBootLoader>
    <div class="atw-container">
      <div class="jobs-loading page-loader">
        <span></span>
        <p>{{ 'atw.jobs.loading' | transloco }}</p>
      </div>
    </div>
  </ng-template>
</main>

<div
  class="job-modal-backdrop"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
  *ngIf="modalOpen"
  (click)="closeJobDetails()"
>
  <div class="job-modal" (click)="$event.stopPropagation()">
    <button type="button" class="job-modal-close" (click)="closeJobDetails()">
      ×
    </button>

    <div class="jobs-loading modal-loader" *ngIf="isDetailsLoading">
      <span></span>
      <p>{{ 'atw.jobsModal.loading' | transloco }}</p>
    </div>

    <ng-container *ngIf="selectedJob && !isDetailsLoading">
      <div class="job-modal-hero">
        <div class="job-modal-title-area">
          <small class="modal-status-pill">
            <span class="modal-pill-icon">✓</span>
            {{ getStatusLabel(selectedJob.status) }}
          </small>

          <h2>{{ getJobTitle(selectedJob) }}</h2>

          <div class="modal-company-line">
            <span>
                    <img class="img-m" src="assets/as/9.webp" >
              {{ getCompanyName(selectedJob) }}
            </span>

            <span>
              <img class="img-m" src="assets/as/21.webp" >
              {{ getCityName(selectedJob) }},
              {{ getCountryName(selectedJob) }}
            </span>
          </div>
        </div>

        <div class="job-modal-salary rightborder">
          <div class="salary-icon">         <img class="img-m" src="assets/as/4.webp" ></div>

          <div>
            <span>{{ 'atw.jobsModal.salary' | transloco }}</span>
            <strong>{{ getSalary(selectedJob) }}</strong>
          </div>
        </div>
      </div>

      <div class="job-details-grid">
        <div class="detail-card rightborder">
      <img class="img-m" src="assets/as/4.webp" >
          <span>{{ 'atw.jobsModal.employmentType' | transloco }}</span>
          <strong>{{ getJobType(selectedJob) }}</strong>
        </div>

        <div class="detail-card rightborder">
              <img class="img-m" src="assets/as/1.webp" >
          <span>{{ 'atw.jobsModal.workModel' | transloco }}</span>
          <strong>{{ getWorkModel(selectedJob) }}</strong>
        </div>

        <div class="detail-card rightborder">
             <img class="img-m" src="assets/as/34.webp" >
          <span>{{ 'atw.jobsModal.postedAt' | transloco }}</span>
          <strong>{{ getPostedAt(selectedJob) }}</strong>
        </div>

        <div class="detail-card rightborder">
              <img class="img-m" src="assets/as/19.webp" >
          <span>{{ 'atw.jobsModal.views' | transloco }}</span>
          <strong>{{ formatNumber(selectedJob.views_count || 0) }}</strong>
        </div>

        <div
          class="detail-card rightborder"
          [class.active-warning]="selectedJob.exam_required"
        >
             <img class="img-m" src="assets/as/17.webp" >
          <span>{{ 'atw.jobsModal.examRequired' | transloco }}</span>

          <strong>
            {{
              selectedJob.exam_required
                ? ('atw.common.yes' | transloco)
                : ('atw.common.no' | transloco)
            }}
          </strong>
        </div>

        <div
          class="detail-card rightborder"
          [class.active-warning]="selectedJob.personality_assessment_required"
        >
         <img class="img-m" src="assets/as/26.webp" >
          <span>{{ 'atw.jobsModal.personalityAssessment' | transloco }}</span>

          <strong>
            {{
              selectedJob.personality_assessment_required
                ? ('atw.common.yes' | transloco)
                : ('atw.common.no' | transloco)
            }}
          </strong>
        </div>
      </div>

      <div
        class="modal-alert-strip"
        *ngIf="
          selectedJob.exam_required ||
          selectedJob.personality_assessment_required
        "
      >
          <img class="img-m" src="assets/as/40.webp" >

        <div>
          <strong>
            {{
              selectedJob.exam_required
                ? ('atw.jobsModal.examRequired' | transloco)
                : ('atw.jobsModal.personalityAssessment' | transloco)
            }}
          </strong>

          <p>

            {{ 'atw.jobsModal.requiredassessment' | transloco }}
          </p>
        </div>
      </div>

      <div class="job-modal-section" *ngIf="getJobDescription(selectedJob)">
        <h3>
<img class="img-m" src="assets/as/12.webp" >
          {{ 'atw.jobsModal.description' | transloco }}
        </h3>

        <p>{{ getJobDescription(selectedJob) }}</p>
      </div>

      <div class="job-modal-section" *ngIf="getJobResponsibilities(selectedJob)">
        <h3>
<img class="img-m" src="assets/as/27.webp" >
          {{ 'atw.jobsModal.responsibilities' | transloco }}
        </h3>

        <p>{{ getJobResponsibilities(selectedJob) }}</p>
      </div>

      <div class="job-modal-section" *ngIf="getTags(selectedJob).length">
        <h3>
  <img class="img-m" src="assets/as/8.png" >
          {{ 'atw.jobsModal.skills' | transloco }}
        </h3>

        <div class="job-keywords modal-tags">
          <small *ngFor="let tag of getTags(selectedJob)">
            {{ tag }}
          </small>
        </div>
      </div>

      <div class="job-modal-section" *ngIf="getRequirements(selectedJob).length">
        <h3>
    <img class="img-m" src="assets/as/35.webp" >
          {{ 'atw.jobsModal.requirements' | transloco }}
        </h3>

        <ul class="requirements-list">
          <li
            *ngFor="
              let req of getRequirements(selectedJob);
              trackBy: trackByRequirementId
            "
          >
            <span class="req-icon">•</span>

            <div>
              <strong>
                {{ getRequirementTypeLabel(req.requirement_type) }}:
              </strong>

              {{ getRequirementText(req) }}

              <small *ngIf="req.is_required">
                {{ 'atw.jobsModal.required' | transloco }}
              </small>
            </div>
          </li>
        </ul>
      </div>

      <div class="job-modal-actions">
        <button
          type="button"
          class="secondary-action"
          (click)="closeJobDetails()"
        >
          ✕
          {{ 'atw.jobsModal.close' | transloco }}
        </button>

        <button
          *ngIf="!isCompanyUser()"
          type="button"
          class="primary-action"
          (click)="applyForJob(selectedJob)"
          [disabled]="isJobApplied(selectedJob)"
        >
          +
          {{ getApplyNowButtonLabel(selectedJob) }}

        </button>
      </div>
    </ng-container>
  </div>
</div>

<div
  class="apply-modal-backdrop"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
  *ngIf="applyModalOpen && !isCompanyUser()"
  (click)="closeApplyModal()"
>
  <div class="apply-modal" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="apply-modal-close"
      (click)="closeApplyModal()"
    >
      ×
    </button>

    <div class="apply-modal-head" *ngIf="selectedApplyJob">
      <span>{{ 'atw.jobsModal.applyNow' | transloco }}</span>

      <h2>{{ getJobTitle(selectedApplyJob) }}</h2>

      <p>
        {{ getCompanyName(selectedApplyJob) }}
        • {{ getCityName(selectedApplyJob) }},
        {{ getCountryName(selectedApplyJob) }}
      </p>
    </div>

    <div class="apply-modal-body">
      <app-atw-cv-uploader
        *ngIf="getApplicationFormType(selectedApplyJob) === 'general'"
        [jobId]="selectedApplyJob?.id"
        (applicationSubmitted)="handleApplicationSubmitted()"
      ></app-atw-cv-uploader>

      <app-applyfordoctor
        *ngIf="getApplicationFormType(selectedApplyJob) === 'doctor'"
        [jobId]="selectedApplyJob?.id"
        (applicationSubmitted)="handleApplicationSubmitted()"
      ></app-applyfordoctor>

      <app-applyfordentist
        *ngIf="getApplicationFormType(selectedApplyJob) === 'dentist'"
        [jobId]="selectedApplyJob?.id"
        (applicationSubmitted)="handleApplicationSubmitted()"
      ></app-applyfordentist>
    </div>
  </div>
</div>

<div
  class="apply-success-backdrop"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
  *ngIf="applySuccessModalOpen"
  (click)="closeApplySuccessModal()"
>
  <div class="apply-success-modal" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="apply-modal-close"
      (click)="closeApplySuccessModal()"
    >
      ×
    </button>

    <div class="success-icon-wrap">
  <img class="img-m" src="assets/as/27.webp" >
    </div>

    <span class="success-badge">
      {{ 'atw.applySuccess.badge' | transloco }}
    </span>

    <h2>
      {{ 'atw.applySuccess.title' | transloco }}
    </h2>

    <p>
      {{ 'atw.applySuccess.text' | transloco }}
    </p>

    <div class="success-check-card">
       <img class="img-m" src="assets/as/30.webp" >

      <div>
        <strong>
          {{ 'atw.applySuccess.checkTitle' | transloco }}
        </strong>

        <small>
          {{ 'atw.applySuccess.checkText' | transloco }}
        </small>
      </div>
    </div>

    <button
      type="button"
      class="primary-action success-done-btn"
      (click)="closeApplySuccessModal()"
    >
      {{ 'atw.applySuccess.done' | transloco }}

    </button>
  </div>
</div>
